// ============================================
// 💊 CATÁLOGO DE MEDICAMENTOS - HEPATOLOGIA/TRANSPLANTE
// ============================================
import { GRAFIAS_USUAIS } from "./substanciasControladas";

export interface MedicamentoCatalogo {
  nome: string;
  apresentacoes: string[];
  posologiaSugerida?: string;
  categoria: string;
}

// Remover acentos para busca
const removerAcentos = (str: string): string => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

// ============================================
// LISTA CURADA DE MEDICAMENTOS
// ============================================
export const catalogoMedicamentos: MedicamentoCatalogo[] = [
  // ═══════════════════════════════════════
  // IMUNOSSUPRESSORES
  // ═══════════════════════════════════════
  {
    nome: "Tacrolimo",
    apresentacoes: ["0,5mg cápsula", "1mg cápsula", "5mg cápsula"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Imunossupressor",
  },
  {
    nome: "Tacrolimo XL",
    apresentacoes: [
      "0,5mg cápsula",
      "1mg cápsula",
      "3mg cápsula",
      "5mg cápsula",
    ],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Imunossupressor",
  },
  {
    nome: "Sirolimo",
    apresentacoes: ["1mg comprimido", "2mg comprimido", "1mg/mL Solução oral"],
    posologiaSugerida: "1 comprimido ao dia.",
    categoria: "Imunossupressor",
  },
  {
    nome: "Everolimo",
    apresentacoes: [
      "0,25mg comprimido",
      "0,5mg comprimido",
      "0,75mg comprimido",
      "1mg comprimido",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Imunossupressor",
  },
  {
    nome: "Micofenolato de mofetila",
    apresentacoes: ["500mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Imunossupressor",
  },
  {
    nome: "Micofenolato sódico",
    apresentacoes: ["180mg comprimido", "360mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Imunossupressor",
  },
  {
    nome: "Azatioprina",
    apresentacoes: ["50mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Imunossupressor",
  },
  {
    nome: "Ciclosporina",
    apresentacoes: ["25mg cápsula", "50mg cápsula", "100mg cápsula"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Imunossupressor",
  },
  {
    nome: "Prednisona",
    apresentacoes: ["5mg comprimido", "20mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Corticosteroide",
  },
  {
    nome: "Prednisolona",
    apresentacoes: ["3mg/mL solução oral", "5mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Corticosteroide",
  },
  {
    nome: "Metilprednisolona",
    apresentacoes: ["500mg frasco-ampola"],
    posologiaSugerida: "Endovenosa conforme protocolo",
    categoria: "Corticosteroide",
  },

  // ═══════════════════════════════════════
  // ANTIVIRAIS - HEPATITE B
  // ═══════════════════════════════════════
  {
    nome: "Entecavir",
    apresentacoes: ["0,5mg comprimido", "1mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "Antiviral HBV",
  },
  {
    nome: "Tenofovir desoproxila",
    apresentacoes: ["300mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiviral HBV",
  },
  {
    nome: "Tenofovir alafenamida (TAF)",
    apresentacoes: ["25mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiviral HBV",
  },
  {
    nome: "Alfapeginterferona 2a",
    apresentacoes: ["180mcg seringa preenchida", "180mcg frasco-ampola"],
    posologiaSugerida:
      "Aplicar 180mcg/1,73m², por via subcutânea, uma vez por semana.",
    categoria: "Antiviral HBV",
  },
  {
    nome: "Imunoglobulina humana anti-hepatite B",
    apresentacoes: ["1.000 UI frasco-ampola"],
    posologiaSugerida:
      "Administrar 1.000 UI, por via intramuscular, 1 (uma) vez ao mês.",
    categoria: "Antiviral HBV",
  },

  // ═══════════════════════════════════════
  // ANTIVIRAIS - HEPATITE C
  // ═══════════════════════════════════════
  {
    nome: "Sofosbuvir",
    apresentacoes: ["400mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiviral HCV",
  },
  {
    nome: "Daclatasvir",
    apresentacoes: ["30mg comprimido", "60mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiviral HCV",
  },
  {
    nome: "Sofosbuvir/Velpatasvir",
    apresentacoes: ["400mg/100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiviral HCV",
  },
  {
    nome: "Glecaprevir/Pibrentasvir",
    apresentacoes: ["100mg/40mg comprimido"],
    posologiaSugerida: "3 comprimidos via oral 1x ao dia",
    categoria: "Antiviral HCV",
  },

  // ═══════════════════════════════════════
  // ANTIVIRAIS - CMV / HERPES
  // ═══════════════════════════════════════
  {
    nome: "Valganciclovir",
    apresentacoes: ["450mg comprimido"],
    posologiaSugerida: "Via oral conforme protocolo",
    categoria: "Antiviral CMV",
  },
  {
    nome: "Ganciclovir",
    apresentacoes: ["500mg frasco-ampola"],
    posologiaSugerida: "Endovenosa conforme protocolo",
    categoria: "Antiviral CMV",
  },
  {
    nome: "Aciclovir",
    apresentacoes: ["200mg comprimido", "400mg comprimido"],
    posologiaSugerida: "Via oral conforme protocolo",
    categoria: "Antiviral Herpes",
  },
  {
    nome: "Valaciclovir",
    apresentacoes: ["500mg comprimido"],
    posologiaSugerida: "Via oral conforme protocolo",
    categoria: "Antiviral Herpes",
  },

  // ═══════════════════════════════════════
  // PROFILAXIA INFECCIOSA
  // ═══════════════════════════════════════
  {
    nome: "Sulfametoxazol + Trimetoprima",
    apresentacoes: ["400mg/80mg comprimido", "800mg/160mg comprimido"],
    posologiaSugerida: "Via oral 3x por semana (seg/qua/sex)",
    categoria: "Antibiótico profilático",
  },
  {
    nome: "Nistatina",
    apresentacoes: ["100.000 UI/mL suspensão oral"],
    posologiaSugerida: "Bochechar e engolir 4x ao dia",
    categoria: "Antifúngico",
  },
  {
    nome: "Fluconazol",
    apresentacoes: ["150mg cápsula", "100mg cápsula"],
    posologiaSugerida: "Via oral conforme protocolo",
    categoria: "Antifúngico",
  },

  // ═══════════════════════════════════════
  // HIPERTENSÃO PORTAL / BETABLOQUEADORES
  // ═══════════════════════════════════════
  {
    nome: "Carvedilol",
    apresentacoes: [
      "3,125mg comprimido",
      "6,25mg comprimido",
      "12,5mg comprimido",
      "25mg comprimido",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Betabloqueador",
  },
  {
    nome: "Propranolol",
    apresentacoes: ["10mg comprimido", "40mg comprimido", "80mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Betabloqueador",
  },
  {
    nome: "Nadolol",
    apresentacoes: ["40mg comprimido", "80mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Betabloqueador",
  },

  // ═══════════════════════════════════════
  // DIURÉTICOS
  // ═══════════════════════════════════════
  {
    nome: "Espironolactona",
    apresentacoes: ["25mg comprimido", "50mg comprimido", "100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Diurético",
  },
  {
    nome: "Furosemida",
    apresentacoes: ["40mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Diurético",
  },
  {
    nome: "Hidroclorotiazida",
    apresentacoes: ["25mg comprimido", "50mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Diurético",
  },
  {
    nome: "Clortalidona + Cloridrato de Amilorida",
    apresentacoes: [
      "25/2,5mg comprimido",
      "25/5mg comprimido",
      "50/5mg comprimido",
    ],
    posologiaSugerida:
      "Tomar 1 comprimido, via oral, 1 vez ao dia, preferencialmente pela manhã.",
    categoria: "Diurético",
  },
  {
    nome: "Cloridrato de amilorida + Hidroclorotiazida",
    apresentacoes: ["25/2,5mg comprimido", "50/5mg comprimido"],
    posologiaSugerida:
      "Tomar 1 comprimido via oral ao dia, pela manhã.Via oral 1x ao dia",
    categoria: "Diurético",
  },

  // ═══════════════════════════════════════
  // ENCEFALOPATIA HEPÁTICA
  // ═══════════════════════════════════════
  {
    nome: "Lactulose",
    apresentacoes: ["667mg/mL xarope"],
    posologiaSugerida:
      "Via oral 15-30mL de 8/8h (ajustar para 2-3 evacuações pastosas/dia)",
    categoria: "Encefalopatia hepática",
  },
  {
    nome: "Rifaximina",
    apresentacoes: ["550mg comprimido", "200mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Encefalopatia hepática",
  },
  {
    nome: "Neomicina",
    apresentacoes: ["500mg comprimido"],
    posologiaSugerida: "Via oral de 6/6 horas",
    categoria: "Encefalopatia hepática",
  },
  {
    nome: "Metronidazol",
    apresentacoes: ["250mg comprimido", "400mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Antibiótico",
  },

  // ═══════════════════════════════════════
  // ANTI-HIPERTENSIVOS
  // ═══════════════════════════════════════
  {
    nome: "Anlodipino",
    apresentacoes: ["2,5mg comprimido", "5mg comprimido", "10mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Anti-hipertensivo",
  },
  {
    nome: "Losartana",
    apresentacoes: ["25mg comprimido", "50mg comprimido", "100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Anti-hipertensivo",
  },
  {
    nome: "Telmisartana",
    apresentacoes: ["40mg comprimido", "80mg comprimido"],
    posologiaSugerida: "Tomar 1 comprimido, via oral, 1 vez ao dia.",
    categoria: "Anti-hipertensivo",
  },
  {
    nome: "Valsartana",
    apresentacoes: [
      "40mg comprimido",
      "80mg comprimido",
      "160mg comprimido",
      "320mg comprimido",
    ],
    posologiaSugerida: "Tomar 1 comprimido, via oral, 1 vez ao dia.",
    categoria: "Anti-hipertensivo",
  },
  {
    nome: "Enalapril",
    apresentacoes: ["5mg comprimido", "10mg comprimido", "20mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anti-hipertensivo",
  },
  {
    nome: "Captopril",
    apresentacoes: ["12,5mg comprimido", "25mg comprimido", "50mg comprimido"],
    posologiaSugerida:
      "Tomar 1 comprimido, via oral, 2 vezes ao dia, 1 hora antes das refeições.",
    categoria: "Anti-hipertensivo",
  },

  // ═══════════════════════════════════════
  // GASTROPROTEÇÃO
  // ═══════════════════════════════════════
  {
    nome: "Omeprazol",
    apresentacoes: ["20mg cápsula", "40mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "IBP",
  },
  {
    nome: "Pantoprazol",
    apresentacoes: ["20mg comprimido", "40mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "IBP",
  },
  {
    nome: "Esomeprazol",
    apresentacoes: ["20mg cápsula", "40mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "IBP",
  },
  {
    nome: "Lansoprazol",
    apresentacoes: ["30mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "IBP",
  },
  {
    nome: "Dexlansoprazol",
    apresentacoes: ["30mg cápsula", "60mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "IBP",
  },

  // ═══════════════════════════════════════
  // DIABETES
  // ═══════════════════════════════════════
  {
    nome: "Metformina",
    apresentacoes: [
      "500mg comprimido",
      "850mg comprimido",
      "1000mg comprimido",
    ],
    posologiaSugerida: "Via oral junto às refeições",
    categoria: "Antidiabético",
  },
  {
    nome: "Glifage XR",
    apresentacoes: [
      "500mg comprimido",
      "850mg comprimido",
      "1000mg comprimido",
    ],
    posologiaSugerida: "Via oral junto às refeições",
    categoria: "Antidiabético",
  },
  {
    nome: "Empagliflozina",
    apresentacoes: ["10mg comprimido", "25mg comprimido"],
    posologiaSugerida: "Tomar 1 comprimido, via oral, 1 vez ao dia.",
    categoria: "Antidiabético",
  },
  {
    nome: "Pioglitazona",
    apresentacoes: ["15mg comprimido", "30mg comprimido", "45mg comprimido"],
    posologiaSugerida: "Tomar 1 comprimido, via oral, 1 vez ao dia.",
    categoria: "Antidiabético",
  },
  // ═══════════════════════════════════════
  // ANÁLOGOS DE GLP-1 — B350 (AI_151)
  // ═══════════════════════════════════════
  // ⚠️ Exigem receita COM RETENÇÃO em 2 vias, validade de 90 dias
  // (RDC ANVISA nº 973/2025 + IN nº 360/2025, Art. 2º). O receituário detecta
  // sozinho pela substância OU pela marca — ver `analogosGLP1.ts`.
  // Apresentações conferidas nos registros brasileiros e validadas por Leonardo
  // (AI_151). Cuidado ao mexer: doses que existem no exterior nem sempre têm
  // registro aqui (a dulaglutida 3 e 4,5 mg, por exemplo, NÃO tem).
  {
    nome: "Semaglutida (injetável)",
    apresentacoes: [
      "0,25mg caneta",
      "0,5mg caneta",
      "1mg caneta",
      "1,7mg caneta",
      "2,4mg caneta",
    ],
    posologiaSugerida: "Via subcutânea, 1x por semana, sempre no mesmo dia",
    categoria: "Análogo GLP-1",
  },
  {
    nome: "Semaglutida (oral)",
    apresentacoes: ["3mg comprimido", "7mg comprimido", "14mg comprimido"],
    posologiaSugerida:
      "Via oral, 1x ao dia em jejum, com até 120 mL de água, 30 min antes da primeira refeição",
    categoria: "Análogo GLP-1",
  },
  {
    nome: "Liraglutida",
    apresentacoes: ["6mg/mL caneta 3mL"],
    posologiaSugerida:
      "Via subcutânea, 1x ao dia (titular 0,6 → 1,2 → 1,8 mg; até 3,0 mg na obesidade)",
    categoria: "Análogo GLP-1",
  },
  {
    nome: "Dulaglutida",
    apresentacoes: ["0,75mg/0,5mL caneta", "1,5mg/0,5mL caneta"],
    posologiaSugerida: "Via subcutânea, 1x por semana, sempre no mesmo dia",
    categoria: "Análogo GLP-1",
  },
  {
    nome: "Tirzepatida",
    apresentacoes: [
      "2,5mg caneta",
      "5mg caneta",
      "7,5mg caneta",
      "10mg caneta",
      "12,5mg caneta",
      "15mg caneta",
    ],
    posologiaSugerida: "Via subcutânea, 1x por semana, sempre no mesmo dia",
    categoria: "Análogo GLP-1",
  },
  {
    nome: "Insulina NPH",
    apresentacoes: ["100 UI/mL frasco 10mL"],
    posologiaSugerida: "Subcutânea conforme glicemia",
    categoria: "Insulina",
  },
  {
    nome: "Insulina Regular",
    apresentacoes: ["100 UI/mL frasco 10mL"],
    posologiaSugerida: "Subcutânea conforme glicemia",
    categoria: "Insulina",
  },
  {
    nome: "Insulina Glargina",
    apresentacoes: ["100 UI/mL caneta 3mL"],
    posologiaSugerida: "Subcutânea 1x ao dia",
    categoria: "Insulina",
  },

  // ═══════════════════════════════════════
  // SUPLEMENTOS / VITAMINAS
  // ═══════════════════════════════════════
  {
    nome: "Vitamina D (Colecalciferol)",
    apresentacoes: [
      "1000 UI comprimido",
      "2000 UI cápsula",
      "5000 UI cápsula",
      "7000 UI cápsula",
      "50000 UI cápsula",
    ],
    posologiaSugerida: "Via oral conforme dosagem sérica",
    categoria: "Vitamina",
  },
  {
    nome: "Cálcio + Vitamina D",
    apresentacoes: ["500mg/200UI comprimido", "600mg/400UI comprimido"],
    posologiaSugerida: "Via oral 1-2x ao dia",
    categoria: "Suplemento",
  },
  {
    nome: "Sulfato ferroso",
    apresentacoes: ["40mg Fe elementar comprimido", "25mg/mL gotas"],
    posologiaSugerida: "Via oral 1x ao dia em jejum",
    categoria: "Suplemento",
  },
  {
    nome: "Sacarato de óxido férrico",
    apresentacoes: ["100mg/5mL ampola"],
    posologiaSugerida:
      "1 ampola EV, diluido em 200 ml de SF 0,9%, 1x por semana, por 10 semanas",
    categoria: "Suplemento",
  },
  {
    nome: "Ácido fólico",
    apresentacoes: ["5mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Vitamina",
  },
  {
    nome: "Vitamina K (Fitomenadiona)",
    apresentacoes: ["10mg comprimido", "10mg/mL ampola"],
    posologiaSugerida: "Via oral ou IM conforme INR",
    categoria: "Vitamina",
  },
  {
    nome: "Complexo B",
    apresentacoes: ["comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Vitamina",
  },
  {
    nome: "Tiamina (Vitamina B1)",
    apresentacoes: ["300mg comprimido", "100mg/mL ampola"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Vitamina",
  },
  {
    nome: "Zinco quelato",
    apresentacoes: ["20mg cápsula", "50mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Suplemento",
  },

  // ═══════════════════════════════════════
  // ANTIBIÓTICOS COMUNS
  // ═══════════════════════════════════════
  {
    nome: "Norfloxacino",
    apresentacoes: ["400mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Antibiótico",
  },
  {
    nome: "Ciprofloxacino",
    apresentacoes: ["250mg comprimido", "500mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Antibiótico",
  },
  {
    nome: "Amoxicilina",
    apresentacoes: ["500mg cápsula", "875mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Antibiótico",
  },
  {
    nome: "Amoxicilina + Clavulanato",
    apresentacoes: ["500mg/125mg comprimido", "875mg/125mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 ou 12/12 horas",
    categoria: "Antibiótico",
  },
  {
    nome: "Cefalexina",
    apresentacoes: ["500mg cápsula", "1000mg cápsula"],
    posologiaSugerida: "Via oral de 6/6 horas",
    categoria: "Antibiótico",
  },
  {
    nome: "Azitromicina",
    apresentacoes: ["500mg cápsula", "1000mg cápsula"],
    posologiaSugerida:
      "Tomar 1 comprimido, via oral, 1 vez ao dia, por 3 dias.",
    categoria: "Antibiótico",
  },
  {
    nome: "Claritromicina",
    apresentacoes: [
      "500mg cápsula",
      "25mg/mL Suspensão oral",
      "50mg/mL Suspensão oral",
      "250mg/5mL Grânulo para suspensão",
    ],
    posologiaSugerida:
      "Tomar 1 comprimido, via oral, 2 vezes ao dia, a cada 12 horas, por 7 a 14 dias.",
    categoria: "Antibiótico",
  },

  // ═══════════════════════════════════════
  // ANTICOAGULANTES
  // ═══════════════════════════════════════
  {
    nome: "Enoxaparina",
    apresentacoes: [
      "20mg/0,2mL seringa",
      "40mg/0,4mL seringa",
      "60mg/0,6mL seringa",
      "80mg/0,8mL seringa",
    ],
    posologiaSugerida: "Subcutânea de 12/12 ou 24/24 horas",
    categoria: "Anticoagulante",
  },
  {
    nome: "Rivaroxabana",
    apresentacoes: [
      "2,5mg comprimido",
      "10mg comprimido",
      "15mg comprimido",
      "20mg comprimido",
    ],
    posologiaSugerida: "Via oral 1x ao dia com alimento",
    categoria: "Anticoagulante",
  },
  {
    nome: "Apixabana",
    apresentacoes: ["2,5mg comprimido", "5mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia com alimento",
    categoria: "Anticoagulante",
  },
  {
    nome: "Varfarina",
    apresentacoes: ["1mg comprimido", "2,5mg comprimido", "5mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia (ajustar conforme INR)",
    categoria: "Anticoagulante",
  },

  // ═══════════════════════════════════════
  // OUTROS COMUNS EM HEPATOLOGIA
  // ═══════════════════════════════════════
  {
    nome: "Ácido ursodesoxicólico",
    apresentacoes: ["50mg cápsula", "150mg cápsula", "300mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia ou dividido em 2-3 tomadas",
    categoria: "Hepatoprotetor",
  },
  {
    nome: "Albumina humana",
    apresentacoes: ["20% frasco 50mL", "20% frasco 100mL"],
    posologiaSugerida: "Endovenosa conforme protocolo",
    categoria: "Hemoderivado",
  },
  {
    nome: "Terlipressina",
    apresentacoes: ["1mg frasco-ampola"],
    posologiaSugerida: "Endovenosa conforme protocolo",
    categoria: "Vasoconstritor",
  },
  {
    nome: "Octreotida",
    apresentacoes: ["0,1mg/mL ampola", "20mg frasco-ampola LAR"],
    posologiaSugerida: "Subcutânea ou EV conforme protocolo",
    categoria: "Análogo somatostatina",
  },
  {
    nome: "Domperidona",
    apresentacoes: ["10mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas antes das refeições",
    categoria: "Procinético",
  },
  {
    nome: "Metoclopramida",
    apresentacoes: ["10mg comprimido", "4mg/mL gotas"],
    posologiaSugerida: "Via oral de 8/8 horas se náuseas",
    categoria: "Antiemético",
  },
  {
    nome: "Ondansetrona",
    apresentacoes: ["4mg comprimido", "8mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas se náuseas",
    categoria: "Antiemético",
  },
  {
    nome: "Dipirona",
    apresentacoes: ["500mg comprimido", "1000mg comprimido", "500mg/mL gotas"],
    posologiaSugerida: "Via oral de 6/6 horas se dor ou febre",
    categoria: "Analgésico",
  },
  {
    nome: "Dexametasona",
    apresentacoes: ["0,5mg comprimido", "4mg comprimido", "4mg/mL ampola"],
    posologiaSugerida: "Via oral ou EV conforme indicação",
    categoria: "Corticosteroide",
  },
  {
    nome: "Sinvastatina",
    apresentacoes: ["10mg comprimido", "20mg comprimido", "40mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Hipolipemiante",
  },
  {
    nome: "Atorvastatina",
    apresentacoes: ["10mg comprimido", "20mg comprimido", "40mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Hipolipemiante",
  },
  {
    nome: "Rosuvastatina",
    apresentacoes: ["5mg comprimido", "10mg comprimido", "20mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Hipolipemiante",
  },
  {
    nome: "AAS (Ácido acetilsalicílico)",
    apresentacoes: ["100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antiplaquetário",
  },
  // ═══════════════════════════════════════════════════════════════════
  // B356 (AI_154) — PSICOFÁRMACOS, ANTICONVULSIVANTES, OPIOIDES, ÁLCOOL
  // Apresentações conferidas na lista CMED/Anvisa (conformidade 09/09/2026),
  // só as COMERCIALIZADAS. O documento de cada uma (receita comum, Controle
  // Especial ou Notificação) NÃO vem daqui: é decidido por
  // `substanciasControladas.ts` a partir da RDC 1.036/2026 — por isso a dose e
  // a forma estão sempre escritas (tramadol ≤100 mg, oxicodona LP ≤40 mg...).
  // ═══════════════════════════════════════════════════════════════════
  // ---------- Antidepressivos (lista C1) ----------
  {
    nome: "Sertralina",
    apresentacoes: ["25mg comprimido", "50mg comprimido", "75mg comprimido", "100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Escitalopram",
    apresentacoes: [
      "10mg comprimido",
      "15mg comprimido",
      "20mg comprimido",
      "5mg comprimido orodispersível",
      "20mg/mL solução oral (gotas)",
    ],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Fluoxetina",
    apresentacoes: ["10mg cápsula", "20mg cápsula", "20mg comprimido", "20mg/mL solução oral (gotas)"],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Antidepressivo",
  },
  {
    nome: "Citalopram",
    apresentacoes: ["20mg comprimido", "40mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Paroxetina",
    apresentacoes: [
      "10mg comprimido",
      "12,5mg comprimido",
      "15mg comprimido",
      "20mg comprimido",
      "25mg comprimido",
      "30mg comprimido",
      "40mg comprimido",
    ],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Antidepressivo",
  },
  {
    nome: "Fluvoxamina",
    apresentacoes: ["50mg comprimido", "100mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antidepressivo",
  },
  {
    nome: "Venlafaxina",
    apresentacoes: [
      "37,5mg cápsula de liberação prolongada",
      "75mg cápsula de liberação prolongada",
      "150mg cápsula de liberação prolongada",
      "37,5mg comprimido",
      "75mg comprimido",
    ],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Desvenlafaxina",
    apresentacoes: ["50mg comprimido de liberação prolongada", "100mg comprimido de liberação prolongada"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Duloxetina",
    apresentacoes: ["30mg cápsula", "60mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Vortioxetina",
    apresentacoes: ["5mg comprimido", "10mg comprimido", "15mg comprimido", "20mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antidepressivo",
  },
  {
    nome: "Bupropiona",
    apresentacoes: ["150mg comprimido de liberação prolongada", "300mg comprimido de liberação prolongada"],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Antidepressivo",
  },
  {
    nome: "Mirtazapina",
    apresentacoes: ["15mg comprimido orodispersível", "30mg comprimido", "45mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antidepressivo",
  },
  {
    nome: "Trazodona",
    apresentacoes: ["50mg comprimido", "100mg comprimido", "150mg comprimido de liberação prolongada"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antidepressivo",
  },
  {
    nome: "Agomelatina",
    apresentacoes: ["25mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia ao deitar",
    categoria: "Antidepressivo",
  },
  {
    nome: "Amitriptilina",
    apresentacoes: ["10mg comprimido", "25mg comprimido", "75mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antidepressivo",
  },
  {
    nome: "Nortriptilina",
    apresentacoes: ["10mg cápsula", "25mg cápsula", "50mg cápsula", "75mg cápsula"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antidepressivo",
  },
  // ---------- Ansiolíticos e hipnóticos ----------
  // Benzodiazepínicos e "drogas Z" são lista B1 → Notificação B (talonário).
  {
    nome: "Clonazepam",
    apresentacoes: [
      "0,25mg comprimido",
      "0,5mg comprimido",
      "2mg comprimido",
      "2,5mg/mL solução oral (gotas)",
    ],
    posologiaSugerida: "Via oral à noite",
    categoria: "Ansiolítico",
  },
  {
    nome: "Alprazolam",
    apresentacoes: [
      "0,25mg comprimido",
      "0,5mg comprimido",
      "1mg comprimido",
      "2mg comprimido",
      "0,5mg comprimido de liberação prolongada",
      "1mg comprimido de liberação prolongada",
      "2mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral à noite",
    categoria: "Ansiolítico",
  },
  {
    nome: "Lorazepam",
    apresentacoes: ["1mg comprimido", "2mg comprimido"],
    posologiaSugerida: "Via oral à noite",
    categoria: "Ansiolítico",
  },
  {
    nome: "Diazepam",
    apresentacoes: ["5mg comprimido", "10mg comprimido"],
    posologiaSugerida: "Via oral à noite",
    categoria: "Ansiolítico",
  },
  {
    nome: "Bromazepam",
    apresentacoes: ["3mg comprimido", "6mg comprimido", "2,5mg/mL solução oral (gotas)"],
    posologiaSugerida: "Via oral à noite",
    categoria: "Ansiolítico",
  },
  {
    nome: "Buspirona",
    apresentacoes: ["5mg comprimido", "10mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Ansiolítico",
  },
  {
    nome: "Zolpidem",
    apresentacoes: [
      "10mg comprimido",
      "5mg comprimido sublingual",
      "6,25mg comprimido de liberação prolongada",
      "12,5mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral ao deitar",
    categoria: "Hipnótico",
  },
  {
    nome: "Eszopiclona",
    apresentacoes: ["2mg comprimido", "3mg comprimido"],
    posologiaSugerida: "Via oral ao deitar",
    categoria: "Hipnótico",
  },
  {
    nome: "Zopiclona",
    apresentacoes: ["7,5mg comprimido"],
    posologiaSugerida: "Via oral ao deitar",
    categoria: "Hipnótico",
  },
  // ---------- Anticonvulsivantes / neuromoduladores (lista C1) ----------
  {
    nome: "Pregabalina",
    apresentacoes: ["25mg cápsula", "50mg cápsula", "75mg cápsula", "100mg cápsula", "150mg cápsula"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Gabapentina",
    apresentacoes: ["300mg cápsula", "400mg cápsula", "600mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Levetiracetam",
    apresentacoes: [
      "250mg comprimido",
      "500mg comprimido",
      "750mg comprimido",
      "1000mg comprimido",
      "100mg/mL solução oral",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Lamotrigina",
    apresentacoes: ["25mg comprimido", "50mg comprimido", "100mg comprimido", "200mg comprimido"],
    posologiaSugerida: "Via oral conforme esquema de titulação",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Topiramato",
    apresentacoes: ["25mg comprimido", "50mg comprimido", "100mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Divalproato de sódio",
    apresentacoes: [
      "250mg comprimido de liberação retardada",
      "500mg comprimido de liberação retardada",
      "250mg comprimido de liberação prolongada",
      "500mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Valproato de sódio",
    apresentacoes: ["300mg comprimido", "500mg comprimido", "50mg/mL xarope"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Ácido valproico",
    apresentacoes: ["250mg cápsula"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Carbamazepina",
    apresentacoes: [
      "200mg comprimido",
      "400mg comprimido",
      "200mg comprimido de liberação prolongada",
      "400mg comprimido de liberação prolongada",
      "20mg/mL suspensão oral",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Oxcarbazepina",
    apresentacoes: ["300mg comprimido", "600mg comprimido", "60mg/mL suspensão oral"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Lacosamida",
    apresentacoes: ["50mg comprimido", "100mg comprimido", "150mg comprimido", "200mg comprimido"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Perampanel",
    apresentacoes: ["2mg comprimido", "4mg comprimido", "6mg comprimido", "8mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia ao deitar",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Fenitoína",
    apresentacoes: ["100mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Anticonvulsivante",
  },
  {
    nome: "Fenobarbital",
    apresentacoes: ["100mg comprimido", "40mg/mL solução oral (gotas)"],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Anticonvulsivante",
  },
  // ---------- Antipsicóticos (lista C1) ----------
  {
    nome: "Quetiapina",
    apresentacoes: [
      "25mg comprimido",
      "100mg comprimido",
      "200mg comprimido",
      "300mg comprimido",
      "50mg comprimido de liberação prolongada",
      "200mg comprimido de liberação prolongada",
      "300mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral à noite",
    categoria: "Antipsicótico",
  },
  {
    nome: "Olanzapina",
    apresentacoes: [
      "2,5mg comprimido",
      "5mg comprimido",
      "10mg comprimido",
      "5mg comprimido orodispersível",
      "10mg comprimido orodispersível",
    ],
    posologiaSugerida: "Via oral 1x ao dia à noite",
    categoria: "Antipsicótico",
  },
  {
    nome: "Risperidona",
    apresentacoes: ["0,5mg comprimido", "1mg comprimido", "2mg comprimido", "3mg comprimido", "1mg/mL solução oral"],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Antipsicótico",
  },
  {
    nome: "Aripiprazol",
    apresentacoes: ["10mg comprimido", "15mg comprimido", "20mg comprimido", "30mg comprimido", "1mg/mL solução oral"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antipsicótico",
  },
  {
    nome: "Brexpiprazol",
    apresentacoes: ["0,5mg comprimido", "1mg comprimido", "2mg comprimido", "3mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Antipsicótico",
  },
  {
    nome: "Lurasidona",
    apresentacoes: ["20mg comprimido", "40mg comprimido", "80mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia, com alimento",
    categoria: "Antipsicótico",
  },
  {
    nome: "Paliperidona",
    apresentacoes: [
      "3mg comprimido de liberação prolongada",
      "6mg comprimido de liberação prolongada",
      "9mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral 1x ao dia pela manhã",
    categoria: "Antipsicótico",
  },
  {
    nome: "Ziprasidona",
    apresentacoes: ["40mg cápsula", "80mg cápsula"],
    posologiaSugerida: "Via oral de 12/12 horas, com alimento",
    categoria: "Antipsicótico",
  },
  {
    nome: "Haloperidol",
    apresentacoes: ["1mg comprimido", "5mg comprimido", "2mg/mL solução oral (gotas)"],
    posologiaSugerida: "Via oral conforme indicação",
    categoria: "Antipsicótico",
  },
  // ---------- Transtorno por uso de álcool ----------
  {
    nome: "Naltrexona",
    apresentacoes: ["50mg comprimido"],
    posologiaSugerida: "Via oral 1x ao dia",
    categoria: "Uso de álcool",
  },
  {
    // Não é controlado (não consta da Portaria 344/98) — receita comum.
    nome: "Baclofeno",
    apresentacoes: ["10mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Uso de álcool",
  },
  // ---------- Analgésicos opioides ----------
  // Tramadol/codeína ≤100 mg por unidade, oxicodona LP ≤40 mg e buprenorfina
  // adesivo → Receita de Controle Especial (adendos). Morfina, metadona e
  // tapentadol → Notificação A (talonário).
  {
    nome: "Tramadol",
    apresentacoes: [
      "50mg cápsula",
      "50mg comprimido de liberação prolongada",
      "100mg comprimido de liberação prolongada",
      "100mg/mL solução oral (gotas)",
    ],
    posologiaSugerida: "Via oral de 8/8 horas se dor moderada a intensa",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Tramadol + Paracetamol",
    apresentacoes: ["37,5mg + 325mg comprimido"],
    posologiaSugerida: "Via oral de 6/6 horas se dor",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Codeína",
    apresentacoes: ["30mg comprimido", "60mg comprimido", "3mg/mL solução oral"],
    posologiaSugerida: "Via oral de 6/6 horas se dor",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Codeína + Paracetamol",
    apresentacoes: ["30mg + 500mg comprimido", "7,5mg + 500mg comprimido"],
    posologiaSugerida: "Via oral de 6/6 horas se dor",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Oxicodona",
    apresentacoes: [
      "10mg comprimido de liberação prolongada",
      "20mg comprimido de liberação prolongada",
      "40mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Oxicodona + Naloxona",
    apresentacoes: [
      "5mg + 2,5mg comprimido de liberação prolongada",
      "10mg + 5mg comprimido de liberação prolongada",
      "20mg + 10mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Buprenorfina",
    apresentacoes: [
      "5mg adesivo transdérmico",
      "10mg adesivo transdérmico",
      "20mg adesivo transdérmico",
    ],
    posologiaSugerida: "Aplicar 1 adesivo na pele a cada 7 dias",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Morfina",
    apresentacoes: [
      "10mg comprimido",
      "30mg comprimido",
      "30mg cápsula de liberação prolongada",
      "60mg cápsula de liberação prolongada",
      "100mg cápsula de liberação prolongada",
      "10mg/mL solução oral (gotas)",
    ],
    posologiaSugerida: "Via oral de 4/4 horas se dor",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Metadona",
    apresentacoes: ["5mg comprimido", "10mg comprimido"],
    posologiaSugerida: "Via oral de 8/8 horas",
    categoria: "Analgésico opioide",
  },
  {
    nome: "Tapentadol",
    apresentacoes: [
      "50mg comprimido de liberação prolongada",
      "100mg comprimido de liberação prolongada",
      "150mg comprimido de liberação prolongada",
    ],
    posologiaSugerida: "Via oral de 12/12 horas",
    categoria: "Analgésico opioide",
  },
  // ---------- Andrógenos (lista C5) ----------
  {
    nome: "Cipionato de testosterona",
    apresentacoes: ["100mg/mL solução injetável"],
    posologiaSugerida: "Via intramuscular conforme indicação",
    categoria: "Andrógeno",
  },
  {
    // Uso tópico: adendo 2 da C5 → receita sem retenção.
    nome: "Testosterona gel",
    apresentacoes: ["10mg/g gel", "16,2mg/g gel"],
    posologiaSugerida: "Aplicar na pele 1x ao dia",
    categoria: "Andrógeno",
  },
];

// ============================================
// 🔍 BUSCA DE MEDICAMENTOS (sem acentos)
// ============================================
// AI_154 (achado ao vivo de Leonardo): digitar "que" trazia Carvedilol porque a
// busca casava a CATEGORIA no meio da palavra ("Betabloqueador"). Agora:
//   - categoria só casa no INÍCIO de uma palavra ("beta", "anti...");
//   - nomes que COMEÇAM com o termo vêm primeiro;
//   - nomes comerciais ("Rivotril", "rivo") trazem o princípio ativo do
//     catálogo, com as doses (mapa conferido na CMED, `GRAFIAS_USUAIS`).
const inicioDePalavra = (texto: string, termo: string): boolean =>
  texto.split(/[\s+\-/()]+/).some((p) => p.startsWith(termo));

export const buscarMedicamentos = (termo: string): MedicamentoCatalogo[] => {
  if (!termo || termo.length < 2) return [];
  const termoNorm = removerAcentos(termo.toLowerCase().trim());
  if (!termoNorm) return [];

  // Marcas que começam com o termo → grafias oficiais do princípio ativo.
  const oficiaisPorMarca = new Set(
    Object.entries(GRAFIAS_USUAIS)
      .filter(([apelido]) => apelido.length >= 4 && apelido.startsWith(termoNorm))
      .map(([, oficial]) => oficial)
  );

  const pontuados: { m: MedicamentoCatalogo; pontos: number }[] = [];
  catalogoMedicamentos.forEach((m) => {
    const nome = removerAcentos(m.nome.toLowerCase());
    const categoria = removerAcentos(m.categoria.toLowerCase());
    const nomeOficial = GRAFIAS_USUAIS[nome] ?? nome;
    let pontos = -1;
    if (nome.startsWith(termoNorm)) pontos = 0;
    else if (inicioDePalavra(nome, termoNorm)) pontos = 1;
    else if (
      Array.from(oficiaisPorMarca).some(
        (o) => nomeOficial === o || inicioDePalavra(nome, o)
      )
    )
      pontos = 2;
    else if (termoNorm.length >= 4 && nome.includes(termoNorm)) pontos = 3;
    else if (inicioDePalavra(categoria, termoNorm)) pontos = 4;
    if (pontos >= 0) pontuados.push({ m, pontos });
  });
  // sort estável: dentro do mesmo nível, mantém a ordem do catálogo
  return pontuados.sort((x, y) => x.pontos - y.pontos).map((x) => x.m);
};
